module.exports = "<div class=\"csv-import-container\">\n  <app-offer-upload></app-offer-upload>\n  <app-csv-upload-errors *ngIf=\"validationErrors\"></app-csv-upload-errors>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/offers/csv-import/csv-import.component.html
// module id = ./src/app/modules/offers/csv-import/csv-import.component.html
// module chunks = main